export default "__VITE_ASSET__GLoat_lB__"